<template>
<div id="select-surveillance">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Programme National {{ year }}</small>
        <br>
        Fiches
      </h1>
      <hr>
    </div>
  </div>
  <div class="panel panel-info">
    <div class="panel-heading">
        <div class="form-inline">
          <div class="form-group">
            <dropdown ref="dropdown">
              <btn class="dropdown-toggle">
                {{ year == null ? '(Année)' : year }}
                <span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-for="y in years" :key="`select-${y}`">
                  <a role="button" @click="year = y">{{ y }}</a>
                </li>
              </template>
            </dropdown>
          </div>
          <div class="form-group" v-if="year != null">
            <div class="input-group">
              <input required
                     ref="input"
                     id="inputSurveillance"
                     tabindex="0"
                     class="form-control"
                     v-model="text"
                     type="text"
                     placeholder="Taper le finess ou le nom"
                     autocomplete="off"/>
            </div>
            <typeahead v-model="surveillance"
                       open-on-focus
                       force-select
                       target="#inputSurveillance"
                       :data="surveillanceList[year]"
                       item-key="value"/>
          </div>
          <div class="form-group" v-if="surveillance != null">
            <dropdown ref="dropdown">
              <btn class="dropdown-toggle">
                {{ module == null ? '(Module)' : moduleName }}
                <span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-for="m in availableModules"
                    :key="m.key">
                  <a role="button" @click="module = m.key">
                    <span :class="`label label-${m.key}`">
                      {{ m.label }}
                    </span>
                  </a>
                </li>
                <li>
                  <a role="button" @click="module = 'denominators'">
                    Fiche établissement
                  </a>
                </li>
                <li v-if="year >= 2026">
                  <a role="button" @click="module = 'toolsUsage'">
                    Fiche formation
                  </a>
                </li>
              </template>
            </dropdown>
          </div>
          <div class="form-group" v-if="year">
            <btn @click="surveillance = null; module = null"
                 :disabled="surveillance == null"
                 type="warning">
              Effacer
            </btn>
          </div>
        </div>
    </div>
  </div>

  <div v-if="surveillance != null || error != null">
    <div v-if="error != null" class="row" id="surveillance-select">
      <div class="col-xs-12 col-md-10 col-lg-8">
        <alert type="danger">
          <p>
            <strong>
              Attention ! Une erreur s'est produite pendant le chargement :
            </strong>
          </p>
          <p>
            {{ error }}
          </p>
        </alert>
      </div>
    </div>
    <div v-else-if="module != null">
      <router-view :config="config"
       :surveillance="surveillance.surveillance"
       :routeBuilder="routeBuilder"
       read-only
       @nav="actions = $event" />
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import modules from '@/sui/data/modules'

export default {
  name: 'select-surveillance',

  data: function () {
    return {
      years: [
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026'
      ],
      year: null,
      surveillance: null,
      module: null,
      error: null,
      refreshing: false,
      text: '',
      routeBuilder: (y, s, m) => {
        if (m !== 'denominators' && m !== 'toolsUsage') {
          return `/mission/sheets/${y}/${s}/module/${m}`
        }

        return `/mission/sheets/${y}/${s}/denominators/${m}`
      },
      config: {
        sheet: {
          showHints: false,
          autoNext: true,
          cheatsheet: false
        },

        general: {
          fixedNav: false
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      listByName: 'surveillances/listByName'
    }),

    moduleName: function () {
      if (this.module == null) {
        return null
      }

      if (this.module === 'denominators') {
        return 'Fiche établissement'
      }
      if (this.module === 'toolsUsage') {
        return 'Fiche formation'
      }

      return modules[this.year][this.module].label
    },

    availableModules: function () {
      const result = []
      this.surveillance.surveillance.availableSheetModules.forEach(
        m => {
          result.push(
            {
              key: m,
              label: modules[this.year][m].label
            }
          )
        }
      )
      return result
    },

    surveillanceList: function () {
      const result = {}
      for (let i = 0; i !== this.years.length; ++i) {
        const y = this.years[i]
        result[y] = this.listByName(y)
      }
      return result
    },

    type: function () {
      return this.$route.params.st
    }
  },

  watch: {
    year: function () {
      this.surveillance = null
      this.module = null
    },

    module: function (value) {
      if (value != null && this.surveillance != null && this.year !== null) {
        const id = this.surveillance.surveillance.id
        this.$router.push(this.routeBuilder(this.year, id, this.module))
      }
    },

    surveillance: function (value, old) {
      this.tab = 0
      if (value != null) {
        if (this.module != null &&
            value.surveillance.modules[this.module] == null) {
          this.module = null
        }
        this.text = value.value
        let load = false
        if (old == null || value.surveillance.id !== old.surveillance.id) {
          load = true
        } else {
          const vk = Object.keys(value.surveillance.modules)
          const ok = Object.keys(old.surveillance.modules)
          if (vk.length !== ok.length) {
            load = true
          } else {
            for (let i in vk) {
              if (ok.indexOf(vk[i]) === -1) {
                load = true
              }
            }
          }
        }
        if (load) {
          this.loadSheets()
        }
      }
    }
  },

  methods: {
    loadSheets: function () {
      if (this.surveillance != null) {
        const promises = [
          this.$store.dispatch(
            'denominators/edit', { s: this.surveillance.surveillance.id }
          ),
          this.$store.dispatch('sheet/loadAll', this.surveillance.surveillance)
        ]

        return Promise.all(promises).catch(e => {
          this.error = `Les données des fiches n'ont pu être récupérées, merci
de vérifier votre connexion internet avant de réessayer. Si le problème
persiste, veuillez contacter l'administrateur du site.`
        })
      }
    }
  },

  mounted: function () {
    const year = this.$route.params.year
    const id = this.$route.params.id
    const module = this.$route.params.st

    for (let y in this.surveillanceList) {
      if (this.surveillanceList[y].length === 0) {
        this.refreshing = true
        this.$store.dispatch('surveillances/all', y).then(
          r => {
            if (r.data.err == null && year === y && id != null) {
              this.module = module
              this.year = year
              this.surveillance = this.surveillanceList[this.year].find(
                s => s.surveillance.id === id
              )
              this.text = this.surveillance.value
            }
          }
        )
      }
    }
  },

  components: {
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#select-surveillance {
  min-height: 100rem;
}
</style>
